import { Link } from 'react-router-dom';
import { getPopularArticles } from '@/mocks/articles';
import { categoryData } from '@/mocks/categories';

export default function HotResources() {
  const popularArticles = getPopularArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-2/3">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-[var(--font-heading)] mb-8">
              热门资源排行
            </h2>
            <div className="space-y-4">
              {popularArticles.map((article, index) => {
                const cat = categoryData.find((c) => c.id === article.category);
                return (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="flex items-start gap-4 p-4 bg-white rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 no-underline group"
                  >
                    <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center text-lg font-bold ${
                      index < 3
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-100 text-foreground-400'
                    }`}>
                      {index + 1}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors mb-1">
                        {article.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-500 line-clamp-1 mb-2">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center gap-3 text-xs text-foreground-400">
                        <span className="px-2 py-0.5 bg-accent-100/80 text-accent-700 rounded-full text-xs">
                          {cat?.name || article.category}
                        </span>
                        <span>{article.date}</span>
                        <span>{article.views.toLocaleString()}次阅读</span>
                      </div>
                    </div>
                    <div className="flex-shrink-0 w-20 h-16 md:w-24 md:h-20 rounded-lg overflow-hidden hidden sm:block">
                      <img
                        src={article.imageUrlThumb}
                        alt={article.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="bg-white rounded-xl border border-background-200/70 p-6 sticky top-24">
              <h3 className="text-lg font-semibold text-foreground-900 mb-4 font-[var(--font-heading)]">
                热门标签
              </h3>
              <div className="flex flex-wrap gap-2">
                {[
                  '人工智能', '电影推荐', '健康养生', '高考志愿',
                  '旅游攻略', '投资理财', '手机摄影', '新能源汽车',
                  '穿搭时尚', '家居收纳', '减税政策', '房价走势',
                ].map((tag) => (
                  <Link
                    key={tag}
                    to="/category/zixun"
                    className="px-3 py-1.5 bg-background-100 text-foreground-600 text-xs rounded-full hover:bg-primary-100/70 hover:text-primary-600 transition-colors no-underline whitespace-nowrap"
                  >
                    {tag}
                  </Link>
                ))}
              </div>

              <div className="mt-8 p-5 bg-accent-100/50 rounded-xl">
                <h4 className="text-sm font-semibold text-accent-800 mb-2">
                  久久网 — 您的优质内容伙伴
                </h4>
                <p className="text-xs text-accent-700 leading-relaxed">
                  每日更新海量优质内容，覆盖8大领域，1,200+篇精选文章，500万+用户的共同选择。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}